import React from "react";
import InputField2 from "../../components/form/InputField2";
import ResourseButtons from "../../components/form/buttons/ResourseButtons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useNotification } from "../../components/notification/NotificationContainer";
import { deleteNation } from "../../features/nationsSlice";
import { closeModal } from "../../features/modalSLice";
import { useForm } from "react-hook-form";

const DeleteNation = ({ id }) => {
  const dispatch = useDispatch();
  const nation = useSelector((state) => state.nations.selected);
  const deleteLoad = useSelector((state) => state.nations.load.deleteNation);
  const navigate = useNavigate();
  const addNotification = useNotification();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const res = await dispatch(deleteNation({ id, reqData: data }));
      if (deleteNation.fulfilled.match(res)) {
        dispatch(closeModal());
        addNotification(res.payload.message, "success");
        return navigate(-1, { replace: true });
      } else {
        addNotification(res.payload.message, "error");
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  return (
    <div className=" min-w-[85vw] sm:min-w-[26rem] lg:min-w-96">
      <div className="    py-6 border-b border-bkg2 mb-4 text-text-1/90">
        <h4>Delete Nation</h4>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <p className="text-center">
          Are you sure you want to delete this nation?
        </p>
        <p className="pt-4 flex justify-center items-center gap-3">
          to confirm type{" "}
          <span className="text-red-500">Delete {nation.name}</span>
        </p>

        <InputField2
          register={register}
          name="description"
          errors={errors.description}
          red
        />

        <ResourseButtons loading={deleteLoad} red submitText="Delete" />
      </form>
    </div>
  );
};

export default DeleteNation;
